let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l7V68")).then(() => parcelRequire('2MI42'));